/* eslint-disable react-hooks/exhaustive-deps */
import {useContext, useEffect} from "react";
import {Link} from "react-router-dom";
import AppContainer from "../../../Components/Structure/AppContainer";
import { Toaster } from "react-hot-toast";
import AddSchoolAdmin from "../../../Components/SystemUsers/AddSchoolAdmin";
import RemoteLogOut from "../../RemoteLogOut";
import useStateCallback from "../../../util/customHooks/useStateCallback";
import TableHeader from "../../../Components/Common/TableHeader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import ResetPassword from "../../../Components/SystemUsers/ResetPassword";
import UpdateSchool from "../../../Components/SystemUsers/UpdateSchool";
import Loader from "../../../Components/Common/Loader";
import AdminContext from "../../../Context/AdminContext";
import Select from "react-select";
import Pagination from "../../../Components/Common/Pagination";
import SchoolContext from "../../../Context/SchoolContext";

function ListSchoolAdminsPage() {
  const [modal, setModal] = useStateCallback(false);
  const {schoolList} = useContext(SchoolContext); 
  const {schoolAdminListByPage, getSchoolAdminListByPage, loading4, loading5, adminMeta, adminPage, adminQuery, adminFirst, adminSchool, setAdminSchool, setAdminQuery, setAdminPage, searchSchoolAdmins} = useContext(AdminContext);

  useEffect(() => {
    if (adminQuery) {
      searchSchoolAdmins();
    } else {
      getSchoolAdminListByPage(adminPage);
    }
  }, [adminPage]);

  const setSchoolAdmins = (e) => {
    e.preventDefault();
    setAdminQuery("");
    setAdminSchool("");
    setAdminPage(1);
    getSchoolAdminListByPage(1);
    
  };

  const handlePagination = (newPage) => {
    if (newPage > 0 && newPage <= adminMeta) {
      setAdminPage(newPage);
    }
  };

  const handleAdminChange = (e) => {
    const value = e.target.value;
    setAdminQuery(value);
    setAdminPage(1);
    if (value === '') {
      setSchoolAdmins(e);
    }
};

const handleReset = (e) => {
    e.preventDefault();
    setSchoolAdmins(e);
  };

  const remoteLogout = (e, item) => {
    setModal(false, () =>
      setModal(
        <RemoteLogOut
          userID={item.user_id}
          isOpen={true}
        />
      )
    );
  };

  const handleUpdate=(e,item)=>{
    setModal(false, ()=>setModal(<ResetPassword accountID={item.user_id} isOpen={true}/>))
    
  }

  const updateSchool=(e,item)=>{
    setModal(false, ()=>setModal(<UpdateSchool adminID={item.school_user_id} g={getSchoolAdminListByPage} isOpen={true}/>))
  }

  const handleAdd=()=>{
    setModal(false, ()=>setModal(<AddSchoolAdmin g={getSchoolAdminListByPage}  isOpen={true}/>))
}
  return (
    <AppContainer title="School Administrators">
       <Toaster
          position="top-center"
          reverseOrder={false}
        />
      <div className="row">
        <div className="col-lg-12 col-md-12 mt-3">
        <div className="card height-auto">
      {modal}
      <div className="card-body">
        <TableHeader
                title="School Administrators List"
                subtitle="List of all the different school administrators"  
                viewButton={
                  <Link onClick={handleAdd} className="btn btn-info" style={{float:"right"}}>Add Admin <i className="fa-solid fa-plus" /></Link>
                     
              } 
              />

        <form className="mg-t-20" onSubmit={searchSchoolAdmins}>
      <div className="row gutters-8">
        <div className="col-9-xxxl col-lg-9 col-12 form-group">
          <div className="row">
          <div className="col-lg-6 mt-2">
              <input
                type="text"
                placeholder="Enter administrator name..."
                style={{ border: "1px solid grey" }}
                value={adminQuery}
                onChange={handleAdminChange}
                className="form-control"
              />
            </div>
            <div className="col-lg-6 mt-2">
            <Select
                onChange={(e) => setAdminSchool(e.school_id)}
                getOptionLabel={(option) => option.school_name}
                getOptionValue={(option) => option.school_id}
                isSearchable
                placeholder="Select school..."
                options={Array.isArray(schoolList) ? schoolList : []}
                value={
                    Array.isArray(schoolList) &&
                    schoolList.find((value) => value.school_id === adminSchool)
                }
            />
            </div>
            
            
            
          </div>
        </div>

        <div className="col-3-xxxl col-lg-3 col-12 form-group">
          <button
            type="submit"
            className="btn-fill-lmd radius-30 text-light shadow-dodger-blue bg-dodger-blue ml-2"
          >
            SEARCH
          </button>
          <button
            type="button"
            onClick={handleReset}
            className="btn-fill-lmd radius-30 text-light shadow-dodger-blue bg-martini mt-2"
          >
            RESET
          </button>
        </div>
      </div>
      </form>
        <div className="border-top mt-3"></div>

        <div className="table-responsive">
          {loading4 || loading5 ? (
        <Loader />
                      ) : (
        <table className="table display data-table text-nowrap">
            <thead>
                <tr>
                <th>No</th>
                <th>Names</th>
                <th>Username</th>
                <th>School Name</th>
                <th>Actions</th>

                </tr>
            </thead>
            <tbody>
                {schoolAdminListByPage.length > 0 ? (
                    schoolAdminListByPage.map((item, index) => (
                    <tr key={index}>
                                      <td>{index + adminFirst + 1}</td>
                                      <td>{item.full_name}</td>
                                      <td>{item.username}</td>
                                      <td>{item.school_name}</td>
                                      <td>
                                        <div className="dropdown">
                                          <Link
                                            to="#"
                                            className="dropdown-toggle"
                                            data-toggle="dropdown"
                                            aria-expanded="false">
                                            <span className="flaticon-more-button-of-three-dots"></span>
                                          </Link>
                                          <div className="dropdown-menu dropdown-menu-right">
                                            <Link
                                              className="dropdown-item"
                                              to="#"
                                              onClick={(e) => handleUpdate(e,item)}>
                                              <i className="fas fa-cogs text-dark-pastel-green"></i>
                                              Reset Password
                                            </Link>
                                            <Link
                                              className="dropdown-item"
                                              to="#"
                                              onClick={(e) => remoteLogout(e,item)}>
                                              <FontAwesomeIcon icon={faArrowRightFromBracket} style={{ color: "red", marginRight: "3px" }} />
                                                  Remote Log-Out
                                              </Link>
                                              <Link
                                              className="dropdown-item"
                                              to="#"
                                              onClick={(e) => updateSchool(e,item)}>
                                              <i
                                                      className="far fa-edit mr-1"
                                                      style={{ color: "orange" }}
                                                    ></i>
                                                  Update School
                                              </Link>
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan="5" style={{ textAlign: "center" }}>
                            No school admins registered yet.
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
      )}
        
      </div>
      <Pagination currentPage={adminPage} totalPages={adminMeta} onPageChange={handlePagination}/>
              
        
      </div>
    </div>
        </div>
      </div>
    </AppContainer>
  );
}

export default ListSchoolAdminsPage;
